export const Colors = {
  primary500: "#72063c",
  primary600: "#640233",
  primary700: "#4e0329",    
  primary800: "#3b021f",
  accent500: "#ddb52f",
};